<template>
  <form>
    <md-card class="mt-4" style="box-shadow:none">
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h2 class="title" style="font-weight:bold!important">
          Edit Profile
        </h2>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Name
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="user.name" />
              <validation-error :errors="apiValidationErrors.nombre" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Email
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="user.email" />
              <validation-error :errors="apiValidationErrors.email" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Phone
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="user.phone" />
              <validation-error :errors="apiValidationErrors.telefono" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Role
          </label>
          <div style="margin-left:20px">
          <md-radio v-model="user.rol" id="snackbar-center" name="snackbar-horizontal" :value="1">Administrator</md-radio>
          <md-radio v-model="user.rol" id="snackbar-center" name="snackbar-horizontal" :value="2">Teacher</md-radio>
          <md-radio v-model="user.rol" id="snackbar-left" name="snackbar-horizontal" :value="3">Student</md-radio>
          </div>
        </div>
        <md-button @click="actualizarUsuario" class="md-info pull-right">
          Edit
        </md-button>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  name: "edit-profile-card",

  props: {
    user: Object,
  },


  watch: {  
      'user.name'(value){  
        this.apiValidationErrors.nombre = [];
      },
      'user.email'(value){  
        this.apiValidationErrors.email = [];
      },
      'user.phone'(value){  
        this.apiValidationErrors.telefono = [];
      }
    },

  components: { ValidationError },
  mixins: [formMixin],

  methods: {
    async actualizarUsuario() {
      try {
        await this.$store.dispatch("users/update", this.user);
        this.$router.push('/users')
        await this.$store.dispatch(
          "alerts/success",
          "Profile updated successfully."
        );
        
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>

<style></style>
